import { getCountFromServer, query, where } from 'firebase/firestore'
import type { PlanningAdjustmentFilter } from '~/features/PlanningAdjustments/planningAdjustmentsModel'
import type { PlanningAdjustmentStatus } from '~/models'
import type { Identifiable } from '~/models/identifiable'
import { PullService } from './servicePull'

const ALL_TYPES = ['customerUnavailable', 'onDemand', 'forcedDeliveryDate']

export class PlanningAdjustmentsCountService extends PullService<
  Identifiable,
  Identifiable[]
> {
  private readonly collection

  constructor() {
    super()
    const { collection } = useFirebase()
    this.collection = collection
  }

  public async getCountByStatus(
    status: PlanningAdjustmentStatus,
    filter: PlanningAdjustmentFilter,
    userId?: string,
  ): Promise<number> {
    let countQuery = query(
      this.collection('PlanningAdjustments'),
      where('Status', '==', status),
      where('Type', 'in', filter === 'all' ? ALL_TYPES : [filter]),
    )

    if (userId) {
      countQuery = query(countQuery, where('UserId', '==', userId))
    }

    const snapshot = await getCountFromServer(countQuery)
    return snapshot.data().count
  }
}
